import ArchetypeAlchemist from './ArchetypeAlchemist'

export default ArchetypeAlchemist
// eslint-disable-next-line import/export
export * from './ArchetypeAlchemist'
